import React, { useEffect, useState } from 'react';
import { Layout, Menu } from 'antd';
import { matchPath, useHistory, useLocation } from 'react-router-dom';

import MenuConfigType from '../../types/MenuConfigType';
import logger from '../../utils/logger';
import styles from './index.module.less';

const {SubMenu} = Menu;

type PropTypes = {
  menu: MenuConfigType[];
};

const SideMenu: React.FC<PropTypes> = ({menu}) => {
  const location = useLocation();
  const history = useHistory();
  const [selectedRoutes, setSelectedRoutes] = useState(getMatchedPaths(menu, location.pathname));

  useEffect(() => {
    const listener = history.listen(() => {
      logger.debug('common', 'SideMenu', `route change identified : ${location.pathname}`);
      setSelectedRoutes(getMatchedPaths(menu, location.pathname));
    });

    return () => {
      listener();
    };
  }, [history, menu, location]);

  const _redirect = (path: string) => {
    history.push(path);
  };

  const renderSubMenu = (item: MenuConfigType) => {
    return (
      item.children &&
      item.privileged && (
        <SubMenu
          data-path={item.path}
          className={styles.yjSubMenuItem}
          icon={typeof item.icon === 'string' ? <div className={item.icon}/> : <item.icon/>}
          key={_makeRouteHash(item.path)}
          title={item.title}
        >
          {renderMenu(item.children)}
        </SubMenu>
      )
    );
  };

  const renderMenuItem = (item: MenuConfigType) => {
    return (
      item.privileged && (
        <Menu.Item
          data-path={item.path}
          className={styles.yjMenuItem}
          onClick={() => _redirect(item.path)}
          icon={typeof item.icon === 'string' ? <div className={item.icon}/> : <item.icon/>}
          key={_makeRouteHash(item.path)}
        >
          {item.title}
          {item.badge && <span className="yjMenuBadge">{item.badge}</span>}
        </Menu.Item>
      )
    );
  };

  const renderMenu = (data: MenuConfigType[]) => {
    return data.map((item) => (item.children && item.children.length > 0 ? renderSubMenu(item) : renderMenuItem(item)));
  };

  return (
    <div className='yjHorizontalMenu'>
      <Menu mode="horizontal" defaultSelectedKeys={selectedRoutes}>
        {renderMenu(menu)}
      </Menu>
    </div>
  );
};

const getMatchedPaths = (routes: MenuConfigType[], location: string) => {
  const matchedPathsArray: string[] = [];
  const generateFlatPathArray = (routeValues: MenuConfigType[], locationValue: string) => {
    if (routeValues) {
      for (const route of routeValues) {
        const matchedRoute = matchPath(locationValue, {
          path: route.path,
          exact: route.exact,
        });
        if (matchedRoute) {
          matchedPathsArray.push(_makeRouteHash(route.path));
        }
        if (matchedRoute && route.children) {
          generateFlatPathArray(route.children, locationValue);
        }
      }
    }
  };

  generateFlatPathArray(routes, location);
  return matchedPathsArray;
};

const _makeRouteHash = (key: string) => {
  return key.split('/').join('');
};

export default SideMenu;
